/* eslint-disable react/destructuring-assignment */
import { Box } from "@mui/material";
import React, { useCallback, useEffect } from "react";

type Props = {
  signUrl: string;
  onSigned: (eventData: object) => void;
  onSignCancel: () => void;
};

export const DocapostIframe = (props: Props) => {
  const handleDocapost = useCallback((event: MessageEvent<any>) => {
    if (event?.data?.mode === "SIGN" && event?.data?.userAction === "OK") {
      props.onSigned(event.data);
    }

    if (
      (event?.data?.mode === "SIGN" && event?.data?.userAction === "CANCEL") ||
      (event?.data?.params?.mode === "SIGN" && event?.data?.params?.userAction === "CANCEL")
    ) {
      props.onSignCancel();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("message", handleDocapost);

    return () => {
      window.removeEventListener("message", handleDocapost);
    };
  }, []);

  return (
    <Box
      component="iframe"
      title="docapost"
      src={props.signUrl}
      sx={{ width: "100%", height: "80vh", border: 0 }}
    />
  );
};
